import React from 'react'

const CollapsibleMenuBurgerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M2.60156 11.6023V10.4023H10.4016V11.6023H2.60156ZM12.5616 11.0023L9.56156 8.00234L12.5616 5.00234L13.4016 5.84234L11.2416 8.00234L13.4016 10.1623L12.5616 11.0023ZM2.60156 8.60234V7.40234H8.60156V8.60234H2.60156ZM2.60156 5.60234V4.40234H10.4016V5.60234H2.60156Z'
      fill='currentcolor'
    />
  </svg>
)

export default CollapsibleMenuBurgerIcon
